import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../auth/AuthorizerContext';

export const PrivateTreeAccessDenied: React.FC = () => {
  const { user } = useAuth();

  return (
    <div className="private-access-denied">
      <div className="private-access-denied-content">
        <h1>This tree isn&apos;t available</h1>
        <p>
          It may be private, or your account may not have permission to view it. If you expected access, try
          signing in or ask the owner to share it with you.
        </p>
        <div className="private-access-denied-actions">
          <Link to="/" className="btn btn-primary">
            Go to home
          </Link>
          {user ? (
            <Link to="/trees" className="btn btn-secondary">
              My trees
            </Link>
          ) : (
            <p className="private-access-denied-hint">
              Already have an account? Use <strong>Sign in</strong> in the menu at the top.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};
